module.exports = __webpack_public_path__ + "SP_SPT5-Birthday-3ee4bc39b32dff3ea8d0f6bb0bb5ebe9.png";